import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import * as commonVar from 'libs/commonVar';

import { CtLicenseRequest } from 'containers';

import classNames from 'classnames/bind';
import styles from './LicenseMenu.css';
const cx = classNames.bind(styles);

class LicenseMenu extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { isAuth } = this.props;

    return <div className={cx('func-list')}>
      {commonVar.isSaas === 1 && (commonVar.isJapan === 0 || isAuth === 2) && <CtLicenseRequest />}</div>;
  }
}

LicenseMenu.propTypes = {
  //
};
LicenseMenu.defaultProps = {
  //
};

const mapStateToProps = (state, props) => {
  return {
    isAuth: state.user.get('isAuth')
  };
};

export default connect(mapStateToProps)(LicenseMenu);



// WEBPACK FOOTER //
// ./src/script/components/license/LicenseMenu.js